module.exports = "/images/Templates 02.jpg";